import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-semibold mt-6" }

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
  } from '@/components/ui/table'
  import {MoreHorizontal, Trash2} from "lucide-vue-next";
  import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuTrigger
  } from "@/components/ui/dropdown-menu";
  import {Button} from "@/components/ui/button";
  import {CoverageElement} from "@/models/tables/coverageElement.interface";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ElementsTable',
  props: {
    elements: {},
    entity: {}
  },
  setup(__props: any) {

  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('building.elements_list')), 1),
    _createVNode(_unref(Table), null, {
      default: _withCtx(() => [
        _createVNode(_unref(TableHeader), { class: "bg-gray-300 font-black" }, {
          default: _withCtx(() => [
            _createVNode(_unref(TableRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(TableHead), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.name')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(TableHead), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.code')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(TableHead), { class: "text-right" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('table.actions')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(TableBody), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.elements, (element) => {
              return (_openBlock(), _createBlock(_unref(TableRow), {
                key: element.code
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TableCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(element.code), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(TableCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(element.description), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(TableCell), { class: "grid justify-end" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DropdownMenu), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DropdownMenuTrigger), { "as-child": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Button), {
                                variant: "ghost",
                                class: "w-8 h-8 p-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(MoreHorizontal), { class: "w-4 h-4" })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(DropdownMenuContent), { align: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(DropdownMenuLabel), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('table.actions')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(DropdownMenuItem), {
                                onClick: _withModifiers(($event: any) => (_ctx.$emit('delete', element)), ["prevent"]),
                                class: "cursor-pointer"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Trash2), { class: "mr-2 h-4 w-4" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('table.delete')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})